import { createDynamicThunk } from ".";

export const getCurrencyListThunk = createDynamicThunk({
  typePrefix: "currencies/getCurrencyListThunk",
  useHandleSearch: true,
});

export const addCurrencyThunk = createDynamicThunk({
  typePrefix: "currencies/addCurrencyThunk",
  endpoint: "/currency",
  method: "POST",
  refreshList: true,
  listThunk: getCurrencyListThunk,
});

export const editCurrencyThunk = createDynamicThunk({
  typePrefix: "currencies/editCurrencyThunk",
  endpoint: "/currency",
  method: "PUT",
  refreshList: true,
  listThunk: getCurrencyListThunk,
});

export const deleteCurrencyThunk = createDynamicThunk({
  typePrefix: "/deleteCurrencyThunk",
  endpoint: "/softDeleteMul",
  method: "POST",
  refreshList: true,
  listThunk: getCurrencyListThunk,
});
